import { css } from '@emotion/react';
import * as React from 'react';

/**
 * `text-transform`, never a transformed string: the DOM keeps `Dupont`, so a screen reader announces
 * a word instead of spelling out `D-U-P-O-N-T`, and a copy into a letter comes out correctly cased.
 */
const surnameStyle = css`
	text-transform: uppercase;
`;

type Props = {
	readonly firstName: string;
	readonly lastName: string;
};

/**
 * A beneficiary's identity, in the order and casing a care record uses: surname in capitals first,
 * then the given name. The capitals are what tell the two apart — `Martin Bernard` or
 * `Robert Thomas` are unreadable without them, and a misread identity is the one error this kind of
 * record cannot afford.
 *
 * Renders inline, with no element of its own beyond the surname's: the caller owns the heading or
 * paragraph and its typography.
 */
const BeneficiaryName: React.FC<Props> = ({ firstName, lastName }) => {
	return (
		<React.Fragment>
			<span css={surnameStyle}>{lastName}</span> {firstName}
		</React.Fragment>
	);
};

export default BeneficiaryName;
